import { forEach, forOwn, } from '.';
/**
 *  Parse the URI's query into keys and values.
 *
 *  Multiple values per key are supported, as are key only query params.
 */
export default function parseQuery() {
    if (!document || !document.location || !document.location.search) {
        return {};
    }
    const queryString = document.location.search;
    // Split the query string into parts after stripping the leading `?`
    const queryParts = queryString.substr(queryString.indexOf('?') === 0 ? 1 : 0).split('&');
    // Split the query parts into key and value if applicable
    // Note: There is no specified query format, so empty values are possible.
    const queryPartsZipped = queryParts
        .map((part) => {
        const eqPos = queryString.indexOf('=');
        return [
            part.substr(0, eqPos > -1 ? eqPos : undefined),
            eqPos > -1 ? part.substr(eqPos + 1) : '',
        ];
    })
        .filter(([key]) => !!key);
    // Transform the parts into a map.
    // Note: keys can be present multiple times,
    // so we will start with assuming multiple values.
    // However, due to the unspecified format,
    // we will not split a single key with comma separated values,
    // as there is no way of knowing if the comma is a separator or a value!
    const queryMap = {};
    forEach(queryPartsZipped, ([key, value]) => {
        queryMap[key] = queryMap[key] || [];
        queryMap[key].push(value);
    });
    // Transform all single length arrays into strings
    const query = {};
    forOwn(queryMap, (values, key) => {
        if (values.length > 1) {
            query[key] = values;
        }
        else {
            query[key] = values[0];
        }
    });
    return query;
}
//# sourceMappingURL=parseQuery.js.map